export enum BayType {
    PalletBay = 1,
    RepairLine = 2,
    SortLine = 3,
    PlantCompPlusLine = 4,
    PlantCompPremLine = 5,
    PlantCompCustLine = 6,
    PlantCompMultiLine = 7,
    PlantSupplyPlusLine = 8,
    PlantSupplyPremLine = 9,
    PlantSupplyCustLine = 10,
    PlantSupplyMultiLine = 11,
    TpmProductionLine = 12,
    WhiteWoodCompLine = 13,
    WhiteWoodSupplyLine = 14,
    PecoCompLine = 15,
    PecoSupplyLine = 16
}
